import { generateAuthHeader } from "../../../commonfunctions/authentication";
import { IClearCartResponse } from "../types";

const clearCart = async (): Promise<IClearCartResponse> => {
  const url = `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/current_order/clear_cart`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...generateAuthHeader().headers,
      },
    });

    if (response.ok) {
      const data = await response.json();
      return {
        status: 200,
        message: "Cart cleared successfully",
        code: "success",
        data: data,
      };
    } else {
      const error = await response.text();
      return {
        status: response.status,
        message: error || "Failed to clear cart",
        code: "failed_result",
      };
    }
  } catch (error) {
    return {
      status: 400,
      message: "Failed to clear cart",
      code: "failed_result",
    };
  }
};

export default clearCart;
